import { Controller } from "@hotwired/stimulus"
import { StreamActions } from "@hotwired/turbo"
import * as bootstrap from "bootstrap"

// Custom Turbo Stream action: <turbo-stream action="close_modal"></turbo-stream>
StreamActions.close_modal = function() {
  const el = document.getElementById("turbo-modal")
  if (el) bootstrap.Modal.getInstance(el)?.hide()
}

// Opens Bootstrap modal when turbo frame content loads into the modal frame
export default class extends Controller {
  connect() {
    this.modal = new bootstrap.Modal(this.element)

    // Listen for turbo:frame-load bubbling up from any frame inside the modal
    // (listening on this.element avoids stale refs when the frame element is replaced)
    this.boundOpen = this.openModal.bind(this)
    this.element.addEventListener("turbo:frame-load", this.boundOpen)

    // Reset frame content when modal is hidden
    this.boundReset = this.resetFrame.bind(this)
    this.element.addEventListener("hidden.bs.modal", this.boundReset)
  }

  disconnect() {
    if (this.boundOpen) {
      this.element.removeEventListener("turbo:frame-load", this.boundOpen)
    }
    if (this.boundReset) {
      this.element.removeEventListener("hidden.bs.modal", this.boundReset)
    }
    if (this.modal) {
      this.modal.dispose()
    }
  }

  openModal() {
    this.modal.show()
  }

  resetFrame() {
    const frame = this.element.querySelector("turbo-frame#modal")
    if (frame) {
      frame.innerHTML = `
        <div class="modal-body text-center py-5">
          <div class="spinner-border text-success" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      `
    }
  }

  // Called from close buttons inside the modal
  close() {
    this.modal.hide()
  }
}
